/**
 * @generated SignedSource<<8caa3a8f0d277a667f09a743b6794d75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Page_SlugS_productizedService$data = {
  readonly id: string;
  readonly publishedAt: ContraAPIScalars.DateTime | null;
  readonly title: string;
  readonly userProfile: {
    readonly displayUsername: string;
    readonly firstName: string | null;
    readonly id: string;
    readonly lastName: string | null;
  };
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceAdminActions_productizedService" | "ProductizedServiceSidebar_productizedService" | "ProductizedService_productizedService">;
  readonly " $fragmentType": "Page_SlugS_productizedService";
};
export type Page_SlugS_productizedService$key = {
  readonly " $data"?: Page_SlugS_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"Page_SlugS_productizedService">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Page_SlugS_productizedService",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayUsername",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedService_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceSidebar_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceAdminActions_productizedService"
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};
})();

(node as any).hash = "6bd923014949fcafbca773e3907f06c7";

export default node;
